import styles from "./MapSearchPanel.module.css";
import { useState } from "react";

type MapSearchPanelProps = {
    city: string;
    onSearch: (query: string) => void;
};

export function MapSearchPanel({ city, onSearch }: MapSearchPanelProps) {
    const [value, setValue] = useState("");

    return (
        <div className={styles.panel}>
            <div className={styles.title}>Поиск по адресу</div>

            <div className={styles.row}>
                <input
                    className={styles.input}
                    placeholder={`Например: Ленина 10, ${city}`}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") onSearch(value);
                    }}
                />

                <button
                    className={styles.button}
                    onClick={() => onSearch(value)}
                >
                    Найти
                </button>
            </div>
        </div>
    );
}
